import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {SpinButtonModule} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonModule';
import {SpinButtonWhileSpinningState} from '@fantasmagames/slot/src/modules/keypad/spinbutton/states/SpinButtonWhileSpinningState';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {GameSpinButtonModule} from 'src/spinbutton/GameSpinButtonModule';

export class GameSpinButtonWhileSpinningState extends SpinButtonWhileSpinningState {
	protected _canContinueSpin: boolean = false;
	protected _spinResponseReceived: boolean = false;

	protected setupEvents(): void {
		super.setupEvents();

		this.on(FlowModuleEvents.CAN_CONTINUE_SPIN, this.onCanContinueSpin);
		this.on(GameSpinButtonModule.REGULATION_SPIN_DELAY_PASSED, this.onRegulationSpinDelayPassed);
	}

	protected onSpaceButtonClicked(): void {
		if (this._canContinueSpin && this._spinResponseReceived) {
			this.onSpinButtonClicked();
		}
	}

	protected onSpinButtonClicked(): void {
		if (this.module.validateQuickStop() && !this._wasQuickstopPressed && this._spinResponseReceived) {
			this.view.disableSpinButton();
			this.emit(SpinButtonEvents.QUICKSTOP_PRESSED);

			this._wasQuickstopPressed = true;
		}
	}

	protected onRegulationSpinDelayPassed(): void {
		if (!this.hasSpinTimeRegulation()) {
			return;
		}

		if ((this.module as GameSpinButtonModule).regulationCanSpin && this.module.canSpin) {
			this.view.enableSpinButton();
			this.module.gotoState(SpinButtonModule.BASIC_STATE);
		}
	}

	protected onCanSpin(): void {
		if (this.hasSpinTimeRegulation()) {
			if ((this.module as GameSpinButtonModule).regulationCanSpin) {
				this.view.enableSpinButton();
				this.module.gotoState(SpinButtonModule.BASIC_STATE);
			}
		} else {
			this.view.enableSpinButton();
			this.module.gotoState(SpinButtonModule.BASIC_STATE);
		}

		this.module.canSpin = true;
	}

	protected onAllReelsStopped(): void {
		this.view.disableSpinButton();

		this._canContinueSpin = false;
		this._spinResponseReceived = false;
	}

	protected onCanContinueSpin(): void {
		if (!this.hasSpinTimeRegulation() && this._spinResponseReceived && this.module.hasQuickstop) {
			this.view.enableSpinButton();
		}

		this._canContinueSpin = true;
	}

	protected onSpinResponse(): void {
		if (this._canContinueSpin) {
			super.onSpinResponse();
		}

		this._spinResponseReceived = true;
	}

	protected hasSpinTimeRegulation(): boolean {
		return (this.module as GameSpinButtonModule).hasSpinTimeRegulation();
	}
}



// WEBPACK FOOTER //
// ./src/spinbutton/states/GameSpinButtonWhileSpinningState.ts